import { render, staticRenderFns } from "./DropdownUser.vue?vue&type=template&id=01c4e5a4&scoped=true&"
import script from "./DropdownUser.vue?vue&type=script&lang=ts&"
export * from "./DropdownUser.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownUser.vue?vue&type=style&index=0&id=01c4e5a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c4e5a4",
  null
  
)

export default component.exports